// i18n area 'networks' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.no-NO.meta.json.
import type { enUS } from './networks'

export const noNO: typeof enUS = {
  networks: {
    common: {
      name: 'Navn',
      scope: 'Scope',
      operState: 'Status',
      actions: 'Handlinger',
      create: 'Opprett',
      close: 'Lukk',
      cancel: 'Avbryt',
      delete: 'Slett',
      edit: 'Rediger',
      save: 'Lagre',
      editError: 'Endringen mislyktes',
      search: 'Søk etter navn',
      empty: 'Ingenting her ennå',
      saveError: 'Kunne ikke lagre',
      loadError: 'Kunne ikke laste — er TVirt-backenden tilgjengelig?',
      createError: 'Opprettelsen mislyktes',
      deleteError: 'Slettingen mislyktes',
      deleteConfirmTitle: 'Slette {name}?',
      deleteConfirmBody: 'Dette kan ikke angres.',
      nameHint: 'Små bokstaver, sifre og bindestreker (DNS-1123)',
      up: 'Aktiv',
      down: 'Ikke aktiv',
      unknown: 'Ukjent',
      usedByVMs: 'VM-er',
      emptyTable: 'Ingen oppføring — legg til en med +-knappen'
    },
    dialogTabs: {
      general: 'Generelt',
      base: 'Basisdefinisjon',
      advanced: 'Avansert konfigurasjon',
      reserved: 'Ranger reservert for TVirt',
      position: 'Posisjon',
      network: 'Nettverkskonfigurasjon',
      hosts: 'Deltakende noder'
    },
    reservedRanges: {
      note: 'Dette er IP-rangene reservert for TVirt, som den kan bruke til automatisk å tildele en adresse til VM-er, containere osv. MERK: IP-ene i disse rangene må ikke brukes utenfor TVirt av eksterne tjenester/apparater.',
      from: 'Fra',
      to: 'Til'
    },
    overlay: {
      title: 'Overlay-nettverk',
      createTitle: 'Opprett overlay-nettverk',
      editTitle: 'Rediger overlay-nettverk',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — tildeles automatisk hvis tomt',
      subnet: 'Subnett',
      subnetHint: 'Overlayets CIDR — IPAM-en avleder registeroppføringen automatisk',
      mtu: 'MTU',
      weight: 'Vekt',
      ceilMbps: 'Tak (Mbps)',
      fairnessHint: 'Vekten gjelder bare under belastning: på en ledig lenke kan hvert nett bruke hele båndbredden. Taket gjelder derimot alltid.',
      contention: 'Konkurranse',
      contentionTip: 'Minst én node observerer tap eller overlimits MED kø på klassen til dette nettverket: uplinkens båndbredde er omstridt og vektene virker. Hvor mye og siden når står i nodens net.shaping.*-serier.',
      firewallPolicy: 'Firewall-policy',
      hosts: 'Hoster',
      hostsTitle: 'Deltakende noder',
      hostsHint: 'Hver node deklarerer sitt underlay-endpoint — en select over nodens REELLE adresser, lest fra nettverkskonfigurasjonen dens; den valgfrie overlay-adressen må ligge i subnettet. Deltakelsen er placement-begrensningen.',
      hostNode: 'Node',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Velg noden først',
      hostAddress: 'Adresse på overlayet (valgfri)',
      hostAddressOutside: 'Utenfor overlay-subnettet ({cidr})',
      addHost: 'Legg til node',
      observedAt: 'Observert',
      attachedNics: 'Tilkoblede NIC-er'
    },
    services: {
      title: 'Nettverkstjenester',
      createTitle: 'Opprett nettverkstjeneste',
      editTitle: 'Rediger nettverkstjeneste',
      kind: 'Type',
      kindCategory: 'Tjenester',
      selectKindHint: 'Velg tjenestetypen — daemonen under er en implementasjonsdetalj TVirt håndterer for deg.',
      kindLabel: {
        dhcp: 'DHCP-server',
        ntp: 'NTP-server',
        vpn: 'VPN-server',
        dns: 'DNS-server',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer og reverse proxy',
        floatip: 'Flytende IP'
      },
      kindDesc: {
        dhcp: 'Tildeler adresser på de betjente subnettene — poolene avledes av nettets subnett, gateway og TVirt-reserverte ranger.',
        dns: 'Autoritativ DNS på de deklarerte sonene — recordene avledes av IPAM-en pluss dine manuelle.',
        gateway: 'Noden fungerer som gateway for et nettverk — NAT (DNAT, 1:1, SNAT/masquerade) pluss statisk ruting mellom de tilkoblede nettene, selvreparerende by design.',
        'lb-rp': 'Lastbalanserer / omvendt proxy foran tjenestene dine — L4- eller L7-lyttere over pooler av medlemmer eller over en Pods klare instanser, omkonfigurert under drift.',
        ntp: 'Nettenes tidstjeneste — relay av eksterne upstream-servere, eller nodens klokke servert til klientene.',
        vpn: 'En VPN-konsentrator på noden — WireGuard eller OpenVPN, du velger: fjerntilgang for klienter på farten, eller en site to site-tunnel mellom to nett.',
        floatip: 'Én adresse som sitter på én frisk App-instans eller Pod om gangen og flytter til neste friske mål når den faller — failover uten daemoner; balanseringen blir hos lastbalansereren.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Den flytende IP-en lever på det valgte nettverket som en EKSTRA adresse inne i holderinstansens eget navnerom: ingen porter, ingen balansering, ingen NAT — klientens IP forblir ekte.',
        address: 'Flytende IP',
        targets: 'Mål',
        targetsHint: 'I PREFERANSE-rekkefølge: det første friske målet holder adressen. En Pod står for alle instansene sine, per replika; hvert mål har sitt eget helsekriterium. Hvert mål må være koblet til samme nettverk.',
        targetKind: 'Mål',
        targetApp: 'App-instans',
        targetPod: 'Pod (alle instanser)',
        targetRef: 'Hvilken',
        health: 'Helse',
        healthRunning: 'Kjører (alle containere klare)',
        healthTcp: 'TCP-tilkobling',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Sti',
        addTarget: 'Legg til mål',
        moveUp: 'Flytt opp',
        moveDown: 'Flytt ned',
        preempt: 'Preempt',
        preemptHint: 'Av (standard): en frisk holder beholder adressen selv når et høyere mål kommer tilbake — ingen flapping. På: det første friske målet holder den alltid.',
        holder: 'Holder',
        noHolder: 'ingen friske mål',
        since: 'siden',
        verdicts: 'Observerte mål',
        healthy: 'frisk',
        unhealthy: 'usunn',
        noVerdict: 'Ikke avgjort ennå — autoritetsnoden skriver den første dommen ved neste gjennomgang.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Denne instansen holder den flytende IP-en {address} til tjenesten {service}'
      },
      poolSource: 'Endepunkter',
      poolSourceMembers: 'Statiske medlemmer',
      poolSourcePod: 'En Pods klare instanser',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Endepunktene følger Pod-en: en instans kommer inn når den kjører med alle containere klare, og forlater straks når den skaleres ned eller dør. Den aktive sjekken er på som standard.',
      poolBackendCount: 'de klare instansene til Pod {pod} på port {port}',
      node: 'Node',
      enabled: 'Aktivert',
      parked: 'Parkert',
      subnets: 'Subnett',
      subnetsHint: 'IPAM-subnettene betjent av denne instansen — poolene avledes av CIDR, gateway og TVirt-reserverte ranger',
      noSubnets: 'Ingen IPAM-subnett — deklarer først et logisk fabric-nett (eller et overlay-subnett): IPAM-en avledes av dem',
      iface: 'Lyttegrensesnitt',
      ifaceHint: 'Vertsgrensesnittet tjenesten åpner socketen sin på (f.eks. en bridge) — påkrevd: en nettverkstjeneste er selvstendig, "alle grensesnitt" finnes ikke lenger',
      dns: 'DNS-servere',
      domain: 'Domene',
      detail: 'Betjener',
      subnetCount: '{n} subnett',
      zones: 'Soner',
      zonesHint: 'Bare autoritativ — daemonen gjør aldri rekursjon. A-recordene avledes av nodenes deklarerte adresser i de refererte IPAM-subnettene; reverse-bryteren betjener også de tilsvarende in-addr.arpa-sonene (PTR). En sone betjenes av maks én DNS-instans i flåten. Den valgfrie nameserveren er FQDN-en skrevet i NS/SOA-recordene i stedet for defaulten ns.<sone>; faller den innenfor sonen, avledes A-recorden dens likevel av den betjenende noden.',
      zoneName: 'Sonenavn',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM-subnett',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Manuelle records',
      zoneRecordsHint: 'En per linje: navn TYPE verdi — typene A, CNAME, MX, TXT. Ved navnekollisjon vinner den manuelle recorden over den avledede.',
      addZone: 'Legg til sone',
      lbListeningHint: 'Instansen erklærer ETT lyttenettverk og ÉN adresse — hver listener binder den på sin egen port; en annen adresse er en annen tjeneste.',
      listeners: 'Listenere',
      listenersHint: 'Hver listener binder instansens adresse på sin egen port i modus L4 (TCP-passthrough — bytene åpnes aldri) eller L7 (HTTP) og videresender til en av poolene nedenfor. Et adresse/port-par betjenes av høyst én instans per node. Endringer trer i kraft i farten — ingen omstart, ingen tapte tilkoblinger.',
      listenerName: 'Navn',
      listenerMode: 'Modus',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP-passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Legg til listener',
      pools: 'Pooler',
      poolsHint: 'Backendene trafikken lander på: statiske medlemmer balansert round-robin eller etter minst opptatt, med en valgfri aktiv health check som tar syke medlemmer ut av rotasjonen.',
      poolName: 'Navn',
      poolAlgorithm: 'Algoritme',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Minst opptatt',
      poolCheck: 'Health check',
      checkNone: 'Ingen',
      checkTcp: 'TCP-tilkobling',
      checkHttp: 'HTTP',
      poolCheckPath: 'Sonde-sti',
      poolInterval: 'Intervall (s)',
      poolMembers: 'Medlemmer',
      poolMembersHint: 'Ett per linje: adresse:port, eventuelt fulgt av en vekt (1-128) — f.eks. 10.0.0.21:8080 2',
      addPool: 'Legg til pool',
      memberCount: '{n} medlemmer',
      listen: {
        assignment: 'Tildeling',
        assignmentStatic: 'Statisk adresse',
        assignmentAuto: 'Automatisk (TVirt-reserverte områder)',
        autoHint: 'TVirt trekker adressen fra det logiske nettverkets reserverte områder og holder den sticky — aldri trukket på nytt ved en redigering eller failover.',
        title: 'Listeners',
        hint: 'En nettverkstjeneste er selvstendig: hver listener erklærer sitt nettverk (overlay, logisk fabric-nettverk eller rått grensesnitt) og en adresse i dets subnett — én listener per adresse, jokertegnet finnes ikke lenger. DNS og NTP kan lytte på flere nettverk og flere adresser i de nettverkene.',
        address: 'Lytteadresse',
        add: 'Legg til listener'
      },
      ntp: {
        mode: 'Synkroniseringsmodus',
        modeRelay: 'Relay av eksterne servere',
        modeNodeClock: 'Nodens klokke',
        modeHint: 'Relayet serverer tiden hentet fra de deklarerte upstream-serverne; nodens klokke serverer tiden til den betjenende noden — som klusteret uansett holder synkronisert',
        servers: 'Upstream-servere',
        serversHint: 'Kommaseparert — hostname eller IP-adresse; tjenesten henter tiden herfra og serverer den til nettet',
        port: 'Lytteport',
        listening: 'Lytter på'
      },
      vpn: {
        engine: 'Motor',
        engineHint: 'Du velger den, og den endres aldri mer: WireGuard er moderne, rask og in-kernel; OpenVPN er kompatibilitetens veteran (TCP, fiendtlige nett)',
        engineLocked: 'Motoren er uforanderlig — en annen motor er en ny tjeneste, nøkler og sertifikater er ikke portable',
        mode: 'Modus',
        modeRemote: 'Fjerntilgang',
        modeSite: 'Site to site',
        modeHint: 'Fjerntilgangen gir klienter på farten en adresse i tunnelen; site to site forener to nett',
        port: 'Lytteport',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard snakker bare UDP',
        tunnelSubnet: 'Tunnel-subnett',
        tunnelSubnetHint: 'Nettet klientene lever i — registrert i IPAM-registeret, det fødes og dør med denne tjenesten',
        dnsServers: 'DNS pushet til klientene',
        routes: 'Ruter pushet til klientene',
        routesHint: 'Kommaseparerte nett som kan nås i tunnelen; tunnel-subnettet er alltid inkludert',
        peers: 'Peere',
        peersHint: 'La den offentlige nøkkelen stå tom, og TVirt genererer paret — og leverer det så med profilen. Lim inn en nøkkel, og peeren beholder sin.',
        clients: 'Klienter',
        clientsHint: 'Hver klient får et sertifikat utstedt av denne tjenestens CA. Å fjerne en klient TILBAKEKALLER den: CRL-en regenereres med en gang.',
        peerName: 'Navn',
        publicKey: 'Offentlig nøkkel',
        publicKeyMinted: 'TVirt genererer den',
        peerAddress: 'Adresse i tunnelen',
        peerAddressHint: 'Tomt = tildeles',
        allowedIps: 'Remote subnett',
        allowedIpsHint: 'Kommaseparert, rutet gjennom denne peeren',
        endpoint: 'Endpoint',
        presharedKey: 'Pre-delt nøkkel',
        keepalive: 'Keepalive (s)',
        addPeer: 'Legg til peer',
        addClient: 'Legg til klient',
        auth: 'Autentisering',
        authTls: 'Sertifikater (TLS)',
        remote: 'Remote endpoint',
        remoteHint: 'host:port for den andre enden — tomt betyr at denne siden venter',
        peerRoutes: 'Remote subnett',
        serverPublicKey: 'Denne serverens offentlige nøkkel',
        ca: 'Sertifikatautoritet',
        listening: 'Lytter på',
        tunnel: 'Tunnel',
        peerCount: '{n} peere',
        download: 'Last ned profil',
        downloadError: 'Kunne ikke eksportere profilen',
        lastHandshake: 'Siste handshake',
        never: 'aldri',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Tilkoblet',
        idle: 'Inaktiv'
      },
      gateway: {
        attach: 'Type lyttenett',
        attachOverlay: 'Overlay-nettverk',
        attachNetwork: 'Logisk fabric-nett',
        attachInterface: 'Rått grensesnitt',
        overlay: 'Overlay-nettverk',
        network: 'Logisk nett',
        interface: 'Grensesnittnavn',
        interfaceHint: 'Et host-grensesnitt TVirt ikke forvalter — adressen tas for god fisk',
        address: 'Lytteadresse (gateway)',
        addressHint: 'Gateway-adressen klientene peker på — innenfor subnettet til lyttenettet',
        dnatTitle: 'DNAT-regler',
        dnatHint: 'Destinasjons-NAT: trafikken i matchen redirigeres til en ny adresse (og eventuelt en ny port). Hvilken som helst protokoll fra listen — porter der protokollen har dem.',
        snatTitle: 'SNAT-regler',
        snatHint: 'Kilde-NAT: trafikken i matchen går ut med kilden omskrevet — en ny eksplisitt adresse (og eventuelt en ny port), eller masquerade på utgangsadressen hvis den står tom.',
        oneToOneTitle: '1:1 NAT-regler',
        oneToOneHint: 'Hver pakke til den eksterne adressen mapper til den interne, og den interne hosten går ut som den eksterne — alle protokoller, begge retninger.',
        external: 'Ekstern adresse',
        internal: 'Intern adresse',
        addOneToOne: 'Legg til 1:1-regel',
        family: 'Familie',
        protocol: 'Protokoll',
        source: 'Kilde (adresse/subnett)',
        destination: 'Destinasjon (adresse/subnett)',
        invert: 'NOT',
        srcPorts: 'Kildeporter',
        dstPorts: 'Dest.-porter',
        dstPortsHint: 'Port eller range (80, 8000-8099)',
        toAddress: 'Ny adresse',
        toPort: 'Ny port',
        snatTo: 'Ny kilde (tom = masquerade)',
        snatToHint: 'Eksplisitt kildeadresse; tomt = masquerade på utgangsadressen',
        addDnat: 'Legg til DNAT-regel',
        addSnat: 'Legg til SNAT-regel',
        routesTitle: 'Statiske ruter',
        routesHint: 'Noden ruter mellom nettene den er koblet til (IP-forwarding er aktiv); disse rutene legger til rekkevidde utover dem — ren kernel, dynamisk ruting kommer med en senere runde.',
        routeDestination: 'Destinasjons-subnett',
        routeGateway: 'Next hop',
        routeMetric: 'Metrikk',
        addRoute: 'Legg til rute',
        listening: 'Lytter på',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} ruter'
      },
      unknownSince: 'Ukjent — siste rapport for {m} min siden',
      lastWord: 'Siste ord',
      reportObservedAt: 'Siste rapport',
      lastErrorRow: 'Siste feil',
      recordsCount: '{n} manuelle records',
      phase: {
        configured: 'Konfigurert',
        running: 'Kjører',
        error: 'Feil'
      },
      authorityNode: 'Authority (tildeling)',
      preferredNode: 'Foretrukket node',
      preferredNodeHint: 'En myk preferanse, aldri en begrensning: ved neste placement-beslutning lander instansen her hvis medlemmet er kvalifisert — alene flytter den ingenting; trekket er "Overfør authority".',
      noPreference: 'Ingen preferanse (automatisk placement)',
      moving: 'I bevegelse',
      movingTooltip: 'Observert her mens authorityen tildeler {node}: trekket er i ferd med å konvergere.',
      placement: {
        title: 'Placement',
        loading: 'Kartlegging pågår…',
        loadError: 'Placement-kartleggingen svarte ikke — prøv igjen senere.',
        draftHint: 'Kartleggingen beregnes ut fra den erklærte nettverkstilkoblingen: den dukker opp når tjenesten er opprettet. Opprettelsen avvises hvis intet medlem kan betjene den, og avslaget navngir mekanismen som tømte mengden.',
        eligibleCount: '{n} av {m} medlemmer kan betjene denne instansen',
        recommended: 'Anbefalt',
        eligible: 'Kvalifisert',
        notEligible: 'Ikke kvalifisert',
        blockedReachability: 'nettverket når ikke frem til dette medlemmet',
        blockedRequireTag: 'blokkert av en påkrevd tagg (requireNodes)',
        blockedExcluded: 'utelukket av simuleringen',
        preferenceUnknown: 'er ikke (lenger) medlem av klusteret',
        preferenceIgnored: 'Preferansen "{node}" er ikke kvalifisert i dag: {reason}. Kartleggingens anbefaling vinner — aldri en feil, tjenesten lever et annet sted.',
        emptyReachability: 'Intet medlem kan betjene denne instansen: nettverket når ikke frem noe sted — ingen flikking på tagger vil hjelpe. Trekk kabel til noden, eller flytt tjenesten dit nettverket er.',
        emptyRequireTag: 'Intet medlem kan betjene denne instansen: det er de påkrevde taggene som tømte mengden — fjern oppføringen fra requireNodes, eller sett taggen på et medlem.',
        spof: 'Single point of failure',
        spofDetail: 'Bare ett medlem kan huse instansen: ved svikt har failoveren ingen steder å gå. En multi-listener-tjeneste flytter som en ENHET — kandidaten må se ALLE dens nettverk: det er prisen.',
        whatIf: 'Simuler fraværende medlemmer',
        whatIfHint: 'Drainens what-if: spør FØR evakueringen, ikke oppdag det først ved failover.',
        survives: 'Med {nodes} fraværende har tjenesten fortsatt et hjem.',
        notSurvives: 'Å evakuere {nodes} etterlater denne tjenesten NEDE: den avledede begrensningen vinner over tilgjengeligheten (R30) — en daemon i live der nettverket ikke når frem, betjener ingen og alarmerer ingen.',
        transfer: 'Overfør authority',
        transferError: 'Overføringen mislyktes',
        transferTarget: 'Målmedlem',
        transferHint: 'Bare kvalifiserte medlemmer tilbys — en preferanse innenfor den gyldige mengden, aldri en override. Ingen task: workernes neste gjennomløp ER trekket (den gamle noden høster, den nye reiser).'
      }
    },
    fabric: {
      tabDerivation: 'Derivasjon',
      importNetwork: 'Importer fra en annen fabric',
      importTitle: 'Importer et logisk nettverk',
      importHint: 'Importen er den eksplisitte tilslutningen: nettverket forblir eierens (samme identitet, samme stem, samme bridge tvf-<stem>) og herfra mappes det på denne fabricens porter/LAGG — å mappe ER å hevde at leveringen ender i samme L2-domene som eierens.',
      importPick: 'Eierens nettverk',
      importNone: 'Ingenting å importere: de andre fabricene har ikke noe eget nettverk som denne fabricen ikke allerede kjenner',
      importedNetworksTitle: 'Importerte nettverk',
      noImported: 'Ingen importerte nettverk',
      importedFrom: 'importert fra {fabric}',
      importedBy: 'Importert av: {list}',
      importedCount: '+{n} importerte',
      owner: 'Eier',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Fjern import',
      unimportConfirm: 'Fjerne importen av nettverket {name} (eier {fabric}) fra denne fabricen? Avvises så lenge en port eller et LAGG i denne fabricen mapper det, eller en gjest, App eller tjeneste bare betjenes gjennom dette benet.',
      unimportRefused: 'Importen er fortsatt i bruk — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Denne noden tar allerede det nettverket fra en annen fabric den er medlem av: en node tar et delt nettverk fra ETT av sine ben (to uplinks på samme L2 i en bridge uten STP er en løkke). Fjern mappingen på portene eller LAGG-et til en av de to fabricene.',
          otherFabricDerived: 'Dokumentet bærer blokken til en fabric som noden ikke lenger erklærer kabel mot: bruk først planen til den fabricen (den foreslår å fjerne enhetene dens), eller ta dem over med take-ownership hvis fabricen er borte.'
        },
        hint: 'O.3-derivasjonsplanen: for hver kablet node tilstanden, diffen avledet-vs-nåværende, den DEKLARERTE bond-topologien, dual-stack-flippene og de strukturerte avslagene/advarslene. Skrivebeskyttet til den EKSPLISITTE applyen — ingenting lander noensinne av seg selv på en node.',
        refresh: 'Last inn planen på nytt',
        empty: 'Ingen node er kablet til denne fabricen (og ingen bærer fortsatt blokken dens).',
        refusal: 'Avslag',
        warning: 'Advarsel',
        generation: 'dokumentgenerasjon {n}',
        state: {
          manual: 'Manuell',
          derived: 'Avledet',
          diverged: 'Avveket'
        },
        topologyTitle: 'Deklarert topologi',
        members: 'medlemmer',
        primary: 'primær',
        held: 'holdt på ETT medlem',
        form: {
          perNetworkBond: 'Bond per nettverk',
          singleBond: 'Enkelt fallback-bond',
          laggBond: 'LACP-bond (LAGG)',
          singlePort: 'Enkelt port'
        },
        colAction: 'Handling',
        colKind: 'Art',
        colDevice: 'Device',
        colDetail: 'Detalj',
        action: {
          add: 'legg til',
          remove: 'fjern',
          replace: 'erstatt'
        },
        diffEmpty: 'Ingen ventende diff — det anvendte dokumentet stemmer med renderen.',
        diffBlocked: 'Ingen diff: avslagene ovenfor blokkerer denne noden.',
        phasePlanned: 'planlagt (trinn 1 av 3)',
        phaseDraining: 'dreneres (trinn 2 av 3)',
        probeUnobserved: 'Drain-sonde: aldri rapportert — tomheten er UKJENT (en retire ville blitt avslått nå).',
        probeFailed: 'Drain-sonde: observasjonen FEILET — de kjente tidsstemplene følger med, aldri et «tomt» ingen har målt.',
        probeActive: {
          one: 'Drain-sonde: {n} etablert forbindelse fortsatt på den gamle adressen',
          other: 'Drain-sonde: {n} etablerte forbindelser fortsatt på den gamle adressen'
        },
        probeLastActive: 'siste aktivitet {time}',
        probeEmpty: {
          one: 'Drain-sonde: tom i {n} minutt',
          other: 'Drain-sonde: tom i {n} minutter'
        },
        probeEmptyUnknown: 'Drain-sonde: tom (siden når er ukjent).',
        impact: '{nics} vNIC og {apps} App på denne noden bruker disse nettverkene: {list}',
        apply: 'Bruk på denne noden',
        applyTitle: 'Bruk derivasjonen — {node}',
        applyIntro: 'Den avledede konfigurasjonen omskriver nettverksdokumentet til {node} ({n} endringer) gjennom samme dør som host-network-editoren — NetworkManager-checkpoint og ærlig probe inkludert. Planens advarsler nedenfor reiser med: les dem før du bekrefter.',
        applyError: 'Apply feilet',
        applyRefused: 'Noden avslo:',
        planMoved: 'Fabricen endret seg etter denne forhåndsvisningen — INGENTING ble anvendt. Planen er lastet inn på nytt: se igjen og prøv på nytt.',
        retire: 'Utfas',
        retireTitle: 'Point of no return — utfasing av {address}',
        restore: 'Gjenopprett',
        restoreTip: 'Tilbake til øyeblikksbildet fra før apply (generasjon {previous}) — angre i ett steg (H13)',
        restoreTitle: 'Gjenopprett forrige dokument — {node}',
        restoreIntro: 'Nettverksdokumentet til {node} går tilbake til øyeblikksbildet tatt før siste apply (generasjon {previous}), skrevet om som generasjon {next} i stedet for {current}. Workeren konvergerer det som ethvert annet dokument.',
        restoreRedo: 'Det erstattede dokumentet blir det nye øyeblikksbildet: å gjenopprette igjen er redo.',
        restoreClosesChain: 'Øyeblikksbildet er det manuelle dokumentet fra før avledningen: kjeden lukkes her — ingen mer angring, noden er manuell til neste apply.',
        restoreConfirm: 'Gjenopprett',
        restoreError: 'Gjenoppretting mislyktes',
        retireIntro: 'Dette fjerner {address} ({network}) fra {point} for godt. Etter denne handlingen er veien tilbake det OMVENDTE flippet — å redeklarere den gamle adressen gjennom samme motor — aldri en blind gjenoppretting.',
        retireOld: 'Gammel adresse (fjernet)',
        retireNew: 'Ny adresse (blir)',
        retireEmptyFact: 'Drain-sonden melder adressen tom: denne fjerningen bryter ingen observert forbindelse.',
        retireConfirm: 'Utfas adressen',
        severActiveLoss: {
          one: 'Bryt {n} etablert forbindelse fortsatt på den gamle adressen — den dør med denne handlingen',
          other: 'Bryt {n} etablerte forbindelser fortsatt på den gamle adressen — de dør med denne handlingen'
        },
        severUnknownLoss: 'Aksepter det UKJENTE: sonden har aldri observert denne adressen (eller observasjonen feiler) — levende forbindelser kan bli brutt.'
      },
      title: 'Fabric',
      createTitle: 'Opprett fabric',
      networks: 'Nett',
      switches: 'Switcher',
      ports: 'Porter',
      laggs: 'LAGG-er',
      subnets: 'Subnett',
      tabOverview: 'Oversikt',
      tabNetworks: 'Logiske nett',
      tabSwitches: 'Switcher',
      overviewHint: 'Fabricen i ett blikk: hvert logiske nett med MTU og subnett (VLAN-ene lever bare i per-port-/per-LAGG-mappingene — samme nett kan reise med forskjellige tagger på forskjellige porter). Fabricen er registeret over en EKSTERN infrastruktur — TVirt observerer og deklarerer, provisjonerer aldri, og rører bare NIC-ene registrert under sin kontroll.',
      absorptionHint: 'Hvert subnett deklarert her AVLEDER sin oppføring i IPAM-registeret i samme skriving — det lever og dør med nettet.',
      scopeFixedHint: 'Scope er fast: klyngens rot — fysisk infrastruktur er per definisjon felles for hele klyngen.',
      networksHint: 'Hvert nett bærer en obligatorisk MTU (default 1500) og et obligatorisk subnett; gateway, DNS-servere og statiske ruter deklarert her er den ENESTE KILDEN for server-NIC-er, Apper og nettverkstjenester.',
      switchesHint: 'Det manuelle registeret: en port er ubrukt, mappet (utagget trafikk og per VLAN-tagg på de logiske nettene) eller medlem av en LAGG — et medlem bærer ingen egne mappinger.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obligatorisk — IPAM-en avleder registeroppføringen automatisk',
      nodeAddressing: 'Nodeadressering',
      nodeAddressingNone: 'Ingen — ingen adresse per node',
      nodeAddressingPool: 'Pool — én fast adresse per betjent node',
      nodeAddressingHint: 'Med Pool tildeler fabric-avledningen hver betjente node en adresse fra områdene reservert for TVirt (fast når den er tildelt).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Reserverte ranger',
      dns: 'DNS-servere (kommaseparert)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway, DNS og ruter deklarert her er den eneste kilden — server-NIC-er, Apper og nettverkstjenester henter herfra',
      routesTitle: 'Statiske ruter',
      routeDestination: 'Destinasjon (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Brukt',
      vlanMappings: 'VLAN-mappinger',
      vlanTag: 'VLAN-tagg',
      vlanNetwork: 'Logisk nett',
      nameTaken: 'Navnet er allerede brukt i fabricen',
      addNetwork: 'Legg til nett',
      editNetwork: 'Rediger nett',
      deleteNetwork: 'Fjern nett',
      deleteNetworkConfirm: 'Fjerne det logiske nettet {name} fra fabricen? Det avledede subnettet dets i IPAM-en dør med det (avvist så lenge en tjeneste eller en App bruker det). Port- og LAGG-tilordninger som peker på det, ryddes.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Fysisk posisjon (valgfri) — samme vokabular som serverplasseringen; bare deklarativ',
      addSwitch: 'Legg til switch',
      editSwitch: 'Rediger switch',
      deleteSwitch: 'Fjern switch',
      deleteSwitchConfirm: 'Fjerne switchen {name} med alle portene dens? LAGG-ene krymper tilsvarende (og dør under to porter).',
      addPort: 'Legg til port',
      editPort: 'Rediger port',
      deletePort: 'Fjern port',
      deletePortConfirm: 'Fjerne porten {name}?',
      untagged: 'Utagget',
      tagged: 'Tagget (tagg:nett)',
      taggedShort: 'Tagget',
      portCabling: 'Kabling',
      portState: 'Status',
      stateUnused: 'ubrukt',
      stateMapped: 'mappet',
      laggPortGuard: 'En port som er medlem av en LAGG redigeres fra LAGG-siden',
      laggsTitle: 'LAGG-er',
      laggsHint: 'En LAGG er 2+ porter i LACP og kan krysse switcher (MLAG, transparent); bare ubrukte porter kommer inn, LAGG-en er mappingflaten, en fjernet port blir ubrukt igjen.',
      addLagg: 'Legg til LAGG',
      editLagg: 'Rediger LAGG',
      deleteLagg: 'Fjern LAGG',
      deleteLaggConfirm: 'Fjerne LAGG-en {name}? Medlemsportene dens blir ubrukte igjen.',
      lacpRate: 'LACP-rate',
      laggPorts: 'Medlemsporter (2+)',
      laggPortsHint: 'Bare ubrukte porter kommer inn — frigjør en mappet port først',
      noNetworks: 'Ingen logiske nett deklarert.',
      noSwitches: 'Ingen switch deklarert.',
      noLaggs: 'Ingen LAGG deklarert.',
      staleConflict: 'En annen operatør har endret denne fabricen mens du redigerte den: lagringen ble avvist så arbeidet hans ikke slettes. Endringene dine er fortsatt her, urørte. Den oppdaterte fabricen er allerede lastet inn på nytt: bekreft på nytt for å legge dem oppå, eller avbryt og se hva som er endret.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Bare avledet: hvert subnett fødes av et logisk fabric-nett eller et overlay — det redigeres ved kilden. De tildelte adressene viser HVEM som holder dem; de TVirt-reserverte rangene er poolene for automatisk tildeling.',
      search: 'Søk etter navn, CIDR eller adresse',
      empty: 'Ingen nett — deklarer et logisk fabric-nett eller et overlay-subnett: IPAM-en avledes av dem automatisk.',
      reserved: 'Ranger reservert for TVirt',
      address: 'Adresse',
      origin: 'Opphav',
      origin_declared: 'deklarert',
      origin_observed: 'observert',
      holder: 'Holdt av',
      noAddresses: 'Ingen kjent adresse i dette subnettet.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Rediger ved kilden'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Brannmurgrupper',
      createTitle: 'Ny brannmurgruppe',
      editTitle: 'Rediger brannmurgruppe',
      empty: 'Ingen brannmurgrupper ennå — opprett en: et gjenbrukbart vokabular av regler, referert fra guest-NIC-ene ved navn.',
      nameHint: 'Bokstaver, sifre og indre . - _; unikt innenfor sitt scope (navnebrødre andre steder skilles med /scope/navn)',
      description: 'Beskrivelse',
      descriptionHint: 'Én linje om hensikten, vist overalt der gruppen velges',
      enforced: 'Håndhevet på scopet',
      enforcedHint: 'Av: rent vokabular — reglene binder bare de NIC-ene som refererer gruppen. På: reglene binder hver guest-NIC med påslått brannmur under gruppens scope, referert eller ei.',
      enforcedChip: 'Håndhevet',
      enforcedChipHint: 'Reglene binder hver guest-NIC med påslått brannmur under gruppens scope, referert eller ei',
      enforceWarning: 'Slås håndhevingen på, binder reglene HVER guest-NIC med påslått brannmur under {scope} ved neste konvergens, også uten eksplisitt referanse — og inne i en aktiv chain er en forfaders drop endelig: nivåene under kan ikke gjenåpne det.',
      unenforceInfo: 'Fjernes håndhevingen, blir reglene bare på de NIC-ene som refererer gruppen eksplisitt.',
      rules: 'Regler',
      tabOverview: 'Oversikt',
      tabRules: 'Regler',
      orderHint: 'Radenes rekkefølge ER evalueringsrekkefølgen innenfor gruppen: den første regelen som matcher, vinner.',
      statefulHint: 'Stateful er implisitt: svarene på tillatt trafikk passerer av seg selv (established/related aksepteres, invalid droppes — injisert av motoren, aldri skrevet for hånd).',
      noRules: 'Ingen regler — et vokabular under oppbygging: å referere det er lovlig og renderer ingenting.',
      addRule: 'Legg til regel',
      direction: 'Retning',
      directionIn: 'Innkommende',
      directionOut: 'Utgående',
      action: 'Handling',
      action_accept: 'Godta',
      action_drop: 'Dropp',
      action_reject: 'Avvis',
      protocol: 'Protokoll',
      protocolAny: 'Enhver',
      ports: 'Porter',
      source: 'Kilde',
      dest: 'Destinasjon',
      comment: 'Kommentar',
      addressHint: 'IPv4-CIDR eller <fabric>/<logisk nett>; tom = enhver',
      moveUp: 'Flytt opp',
      moveDown: 'Flytt ned',
      nicFirewall: 'Brannmur',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Brannmurgrupper',
      nicGroupsPlaceholder: 'Velg en gruppe…',
      nicGroupsHint: 'De synlige gruppene, inkludert dem fra de overordnede scopene (kan brukes nedover, som tagger)',
      nicGroupCount: { one: '{n} brannmurgruppe', other: '{n} brannmurgrupper' },
      nicOff: 'Brannmur av',
      pendingRestartHint: 'Brannmurendringer følger den lagrede/anvendte modellen: de venter på neste power cycle (PendingRestart). Grupper håndhevet av overordnede scopes gjelder når NIC-ens brannmur er på.',
      appConvergeHint: 'Brannmurendringer trer i kraft ved containerens neste konvergens. Grupper håndhevet av overordnede scopes gjelder når brannmuren er på.',
      enforcedAncestors: 'Håndhevet av overordnede scopes',
      enforcedAncestorsHint: 'Denne gruppen gjelder for hver NIC under sitt scope hvis brannmur er PÅ — bryteren er NIC-ens hovedbryter (av = ingen chain i det hele tatt, forfedre medregnet); inne i en aktiv chain er forfaderens autoritet endelig: dens drop gjenåpnes ikke nedenfor.'
    }
  }
}
